import React from 'react';

export const BadgeComp = ({ text, status = 'active' }) => (
  <div className={`custom-badge badge-${status} ml-1 mr-1`}>{text}</div>
);
